import { render, staticRenderFns } from "./GoodsNav.vue?vue&type=template&id=38764e96&scoped=true&"
import script from "./GoodsNav.vue?vue&type=script&lang=js&"
export * from "./GoodsNav.vue?vue&type=script&lang=js&"
import style0 from "./GoodsNav.vue?vue&type=style&index=0&id=38764e96&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38764e96",
  null
  
)

export default component.exports